import { CustomDialog } from '../../../components/CustomDialog';
import { useState } from 'react';
import { useAppDispatch } from '../../../storeHook';
import { showAlert } from '../../../services/alert';
import {
  useRetailerBlockMutation,
  useRetailerUnblockMutation,
} from '../../../services/blockUnblockRetailer';
import {
  TBlockScope,
  TBlockUnblockRetailerData,
} from '../../../utils/types';
import * as yup from 'yup';
import {
  InputController,
  Button,
} from '../../../components';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';

const formSchema = yup.object({
  reason: yup.string().required('Please specify reason'),
});
type TFormData = yup.InferType<typeof formSchema>;

export const BlockUnblockAction: React.FC<{
  blockUnblockDetails?: TBlockUnblockRetailerData;
  blockScope: TBlockScope;
}> = ({ blockUnblockDetails, blockScope }) => {
  const isBlocked = blockUnblockDetails?.isBlocked;
  const retailerId = blockUnblockDetails?.retailerId;
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);

  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const [blockRetailer] = useRetailerBlockMutation();
  const [unblockRetailer] = useRetailerUnblockMutation();
  const onBlockOrUnblockAction = (data: TFormData) => {
    retailerId &&
      (isBlocked
        ? unblockRetailer({
            retailerId: retailerId,
            unblockReason: data.reason,
            blockScope: blockScope,
          })
        : blockRetailer({
            retailerId: retailerId,
            blockReason: data.reason,
            blockScope: blockScope,
          })
      )
        .unwrap()
        .then(() => {
          dispatch(
            showAlert({
              content: `Retailer ${
                isBlocked ? 'unblocked' : 'blocked'
              } successfully`,
            })
          );
        })
        .catch((err) => {
          console.log('error', err);
          // this.utility.handleError(err);
        });
  };

  const actionName = isBlocked ? 'Unblock' : 'Block';
  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-3"
        variant="button--secondary">
        {actionName}
      </Button>
      <CustomDialog
        dialogTitle={`${actionName} Retailer`}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onBlockOrUnblockAction(data)
        )}
        actionText={{
          submit: actionName,
          cancel: 'Cancel',
        }}
        maxWidth="sm">
        <InputController
          label={`Reason for Retailer ${actionName}`}
          register={register('reason')}
          error={errors.reason?.message}
          required
        />
      </CustomDialog>
    </>
  );
};
